import React from "react"
import styled from "styled-components"
import { WIDTH } from "@/constants"
import { BREAKPOINTS } from "@/styles/themeSettings"
import GridContainer from "@/components/common/GridContainer"
import VideoWithCover from "@/components/common/VideoWithCover"
import { getPropSafely } from "@/utils/utils"

const Wrapper = styled(GridContainer)`
	position: relative;
	width: 100vw;

	&.width {
		&-${WIDTH.FULL}, &-${WIDTH.MEDIUM}, &-${WIDTH.SMALL} {
			> * {
				grid-column: 1 / calc(var(--grid-count) + 1);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		&.width {
			&-${WIDTH.FULL} {
				> * {
					grid-column: 1 / calc(var(--grid-count) + 1);
				}
			}

			&-${WIDTH.MEDIUM} {
				> * {
					grid-column: 4 / calc(var(--grid-count) - 2);
				}
			}

			&-${WIDTH.SMALL} {
				> * {
					grid-column: 6 / calc(var(--grid-count) - 4);
				}
			}
		}

		&.expand-on-scroll {
			height: auto;
			width: 50%;
		}
	}
`

const Asset = ({ data, className = "" }) => {
	const width = getPropSafely(data, "width", WIDTH.FULL)
	// const width = WIDTH.SMALL

	return (
		<Wrapper className={` ${className} no-margin padding width-${width}`}>
			<VideoWithCover data={data} className="ignore-indent" />
		</Wrapper>
	)
}

export default Asset
